
import styles from '../style.module.css';
import langData from "../../../lang/data";
import {useSelector} from "react-redux";
import NewsItem from "./NewsItem";

function News({ news }) {

    const { currentLanguage } = useSelector(({ main }) => main);

    return (
        <div className={styles.news_section}>
            <h3>{ langData.titles.BlogTitleSecond[currentLanguage] }</h3>
            <div className={styles.news_content}>
                {
                    news.slice(0.4).map((item, i) => (
                        <NewsItem
                            key = { item.id }
                            news = { item }
                        />
                    ))
                }
            </div>
        </div>
    )
}

export default News;